import { render } from "./DeliverySheet.vue?vue&type=template&id=ef1325c0&scoped=true"
import script from "./DeliverySheet.vue?vue&type=script&lang=js"
export * from "./DeliverySheet.vue?vue&type=script&lang=js"

import "./DeliverySheet.vue?vue&type=style&index=0&id=ef1325c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef1325c0"]])

export default __exports__